import { render, staticRenderFns } from "./QuestionnaireQuestionMixin.vue?vue&type=template&id=48db8822"
import script from "./QuestionnaireQuestionMixin.vue?vue&type=script&lang=js"
export * from "./QuestionnaireQuestionMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports